import styled from 'styled-components';

const Tab = styled.button`
  flex:1; 
  padding: ${({theme})=>theme.spacing[0]};
  font-size: ${({theme})=>theme.fontSizes.xl};
  border-radius: ${({theme})=>theme.radii.xl};
  border: 4px solid ${({theme})=>theme.colors.background};
  background: ${({theme})=>theme.colors.backgroundReverse};
  color : ${({theme})=>theme.colors.textReverse};
  cursor: pointer;
`;

export default Tab;